module.exports = __webpack_public_path__ + "img/radios.6660e9fa.png";